import { ChangeDetectorRef, Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertController, App, IonicPage, ModalController, NavController, NavParams,LoadingController } from 'ionic-angular';
import { ApiProvider } from '../../providers/api/api';
// import { LeadsPage } from '../leads/leads';
// import { SearchPage } from '../search/search';

/**
 * Generated class for the LeadsTabsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-leads-tabs',
  templateUrl: 'leads-tabs.html',
})
export class LeadsTabsPage {

  constructor(public navCtrl: NavController, public navParams: NavParams, public modalCtrl: ModalController, private alertCtrl: AlertController) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad LeadsTabsPage');
  }
  goBack(){
    this.navCtrl.pop() 
  }

  postHScodesPage () {
    console.log("hitted");
    this.navCtrl.push('LeadsPage');
    
    // this.navCtrl.parent.select(1);
  }


  openUseLeadsModal() {
    let modal = this.modalCtrl.create(UseLeadsModel);
    modal.present();
  }

  openAddLeadsModal() {
    let modal = this.modalCtrl.create(AddLeadsModel);
    modal.present();
  }

  gotoSearchPage() {
    this.navCtrl.push('SearchPage');
  }


  LogOut() {
    this.logOutAlert();
  }

  logOutAlert() {
    const alert = this.alertCtrl.create({
      cssClass: 'my-custom-class',
      subTitle: 'Are you sure you want to Logout?',
      buttons: [{
        text: 'No', 
        handler: () => {
        }
      },{
        text: 'Ok', 
        handler: () => {
          localStorage.clear();
          window.location.reload();
        }
      },
    ]
    });
    alert.present();
  }
  gotopage(id){
    if(id==0){
      this.navCtrl.setRoot('HomePage');
    }else if(id==1){
      this.navCtrl.push('StartLeadsPage'); 
    }else if(id==2){
      // this.navCtrl.push('ToolkitPage');
       // this.navCtrl.push('ToolkitPage');
    this.navCtrl.push('LoginPage');
    }else if(id==3){
      this.navCtrl.push('ChatChaptersPage');
    }else if(id==4){
      this.navCtrl.push('LeadsTabsPage');
    }
  
  }

}



// AddLeadsModel New Component Start 



@Component({
  selector: 'page-use', 
  templateUrl: 'use-leads.html',
})
export class UseLeadsModel { 

  data: any;
  use: boolean =  false;
  ProductData: any[] = [];
  hscode: any;
  country;
  constructor(public navCtrl: NavController, public navParams: NavParams, private apiProvider: ApiProvider, public app: App) {
  }

  search() {
    let flagSelection: any = localStorage.getItem('flagSelection') || '';
    if(flagSelection) {
      flagSelection = JSON.parse(flagSelection);
      this.country = flagSelection.country_id;
    } else {
      let countryJSON = JSON.parse(localStorage.getItem('user_data')) ;
      this.country =  countryJSON[0].usr_country;
    }
  
   const data = {
     'country_id' : this.country,
     'searchdata' : this.data
   } 
   console.log(data);
   this.apiProvider.searchProductName(data).subscribe((res: any) => {
    // console.log(res)
    this.ProductData = res.data;
    console.log(this.ProductData);
    this.use = false;
  }, er => {
    console.log(er);
  })
  }

  public usecode(data) {
    console.log(data);
    this.hscode = this.ProductData[data].tl;
    this.use = true;
  }

  autoFillDetails() {
    const data = {
      'hscode': this.hscode,
      'country_id':  this.country,
    }
    console.log(data);
    this.apiProvider.dontKnowHscode(data).subscribe((res: any) => {
      console.log(res);
      // this.app.getRootNav().setRoot(LeadsPage, { 'know': true, 'kdata': JSON.stringify(res.data) });
      this.navCtrl.setRoot('LeadsPage', { 'know': true, 'kdata': JSON.stringify(res.data) });
      // this.navCtrl.parent.select(1);
      // this.tabs.getByIndex(1).push(LeadsPage, { 'know': true, 'kdata': JSON.parse(res.data) });
      this.use = false;
    }, er => {
      console.log(er);
    })

  }

  closeModal() {
    this.navCtrl.pop();
  }


}


// AddLeadsModel New Component Start


@Component({
  selector: 'page-add', 
  templateUrl: 'add-leads.html',
})
export class AddLeadsModel { 
  continent_nm:any;country_nm:any;state_nm:any;
  addHscodeForm: FormGroup;allStates:any;countrys:any;
  allCountrys:any = [];
  loading:any;state:any;cntry:any;cntnt:any;usr_continent:any;
  usr_name:any;usr_mobile:any;usr_email:any;usr_address:any;continents:any;profiledata:any;
  constructor( private changeDectorRef: ChangeDetectorRef,private alertCtrl: AlertController,public loadingCtrl: LoadingController,public navCtrl: NavController, public navParams: NavParams, private apiProvider: ApiProvider, private fb: FormBuilder) {

    // this.getContinent
    var user_data = JSON.parse(localStorage.getItem('user_data'));
    this.profiledata=user_data[0];
    console.log(user_data);
    
    this.usr_name=user_data[0].usr_nm;
    this.usr_mobile=user_data[0].usr_ph;
    this.usr_email=user_data[0].usr_email;
    this.usr_address=user_data[0].usr_address;
    this.usr_continent=user_data[0].usr_continent;
    this.getContinent();
    this.continentsdata();
    this.addHscodeForm = fb.group({
      name: [this.usr_name, [Validators.required]],
      email: [this.usr_email, [Validators.required]],
      mobile: [this.usr_mobile, [Validators.required]],
      address: [this.usr_address, [Validators.required]],
      organisation: ['', ], 
      url: ['', [Validators.required]], 
      hscode: ['', [Validators.required]],
      usr_continent: ['', [Validators.required]],
      usr_state: ['', [Validators.required]], 
      usr_country: ['', [Validators.required]], 
      country: ['', [Validators.required]],
      product: ['', [Validators.required]],
      description: ['', [Validators.required]],
    })

   

  }
  ngAfterViewChecked(): void {
    this.changeDectorRef.detectChanges();

  }

 
  addhscodesvalidSubmit() {
    const usrdata = JSON.parse(localStorage.getItem('user_data'));
    
    console.log(this.addHscodeForm);
    if (this.addHscodeForm.invalid) {
      return;
    } else { 
      this.presentLoadingIos();
      var data = {
        'name': this.addHscodeForm.value.name,
        'mobile': this.addHscodeForm.value.mobile,
        'email': this.addHscodeForm.value.email,
        'address': this.addHscodeForm.value.address,
        'organisation': this.addHscodeForm.value.organisation,
        'url': this.addHscodeForm.value.url,
        'hscode': this.addHscodeForm.value.hscode,
        'country_id': this.addHscodeForm.value.country.country_id,
        'product_name': this.addHscodeForm.value.product,
        'description': this.addHscodeForm.value.description,
        'usr_continent': this.continent_nm,
        'usr_state': this.state_nm,
        'usr_country': this.country_nm,
        'usr_id': usrdata[0].usr_id, 
      }
      console.log(data);
      this.apiProvider.addhscode(data).subscribe((res: any) => { 
        this.loading.dismiss();
        if (res.status == 200) {
          this.addHscodeForm.reset();
          const alert = this.alertCtrl.create({
            cssClass: 'my-custom-class',
            title: res.referral + ' - Congratulations!',
            subTitle:'Your Request has received and our team will get back to you in next 72 Hrs', 
            mode:'ios',
            buttons: [{
              text: 'Ok',
              handler: () => {  
                this.closeModal();
                
          
              }
            },  
            ]
           
          });
          alert.present();  
        }
      }, er => { 
        this.alert(er);
       
      })

    }
  }
  get signupformControl() {
    return this.addHscodeForm.controls;
  }
  getStatesData(data) {
    this.country_nm=data.value.country_id
    const sdata = { 'country_id': data.value.country_id }
    
     this.apiProvider.getStatesdata(sdata).subscribe((res: any) => {
       console.log(res.data)
       this.allStates = res.data;
       console.log(this.allStates);
       var statefilterdata=res.data.filter(word=>word.state_id == this.profiledata.usr_state);
       this.state=statefilterdata[0].state_nm;
       this.state_nm=statefilterdata[0].state_nm;
       }, er => {
       console.log(er);
     })  
   }
   getcities(data){
    this.state_nm=data.value.state_nm; 
   }

   getCountry(data) { 
     this.continent_nm=data.value.continent_id
   console.log(data);
   
    var cont = {
      'continent_id': data.value.continent_id
    }
    this.apiProvider.getCountrysdata(cont).subscribe((res: any) => {
      // console.log(res.data)
      this.countrys = res.data;
      var countryfilterdata=res.data.filter(word=>word.country_id == this.profiledata.usr_country);
      this.cntry=countryfilterdata[0].country_nm;
      console.log(this.countrys)
      var statedata={
        value:{
          country_id:countryfilterdata[0].country_id,
        }
      }
      this.getStatesData(statedata);
    }, er => {
      console.log(er);
    })
    // this.continent_id = data.value.continent_id;
  }
   continentsdata() {
    this.apiProvider.getContinentdata().subscribe((res: any) => {
      console.log(res.data)
      this.continents = res.data;
      var continentsfilterdata=res.data.filter(word=>word.continent_id == this.profiledata.usr_continent)
      console.log(continentsfilterdata,this.profiledata.usr_continent);
      
      this.cntnt=continentsfilterdata[0].continent_nm;
      var data={
        value:{
          continent_id:continentsfilterdata[0].continent_id,
        }
      }
      this.getCountry(data);
      // this.cntnt = res.data.filter(word => word.continent_id == this.usr_continent);
      // console.log("venki",this.cntnt);
      
      // this.addHscodeForm.value.usr_continent=this.cntnt[0].continent_nm
      // // this.usr_continent
      // console.log(this.addHscodeForm.value.usr_continent);
    }, er => {
      console.log(er);
    })
  }

  private getContinent () {
    this.presentLoadingIos();

    this.apiProvider.getallCountrys().subscribe((res: any) => {
      this.loading.dismiss();
      console.log(res.data)
      this.allCountrys = res.data;
      console.log(this.allCountrys);
    }, er => {
      this.loading.dismiss();
      console.log(er);
    })  
  }
  closeModal() {
    this.navCtrl.pop();
  }
  presentLoadingIos() {
    this.loading = this.loadingCtrl.create({
      spinner: 'ios',
      content: 'Please wait...'
    });
    this.loading.present();
  } 


    alert(data) {
      const alert = this.alertCtrl.create({
        cssClass: 'my-custom-class',
        title: data,
        mode: 'ios',
        subTitle: '',
        buttons: ['OK']
      });
      alert.present();
    }

}



// WEBPACK FOOTER //
// ./src/pages/leads-tabs/leads-tabs.ts